import { Table } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { KeyedRow } from '../../components/KeyedRow';
import { PageHeader } from '../../components/PageHeader';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import { EodVatRow } from './components/EodVatRow';
import type { EodVatDto } from './types/EodVatDto';

export function EodVats() {
	const { organisation } = useParams();

	const filter = useFilter();
	const pagination = usePagination();

	const eodVatQuery = queryWithFilterAndPages<EodVatDto[]>(
		`${organisation}/eod-vat/all`,
		filter.value,
		pagination.value,
	);

	const eodVatCountQuery = queryWithFilter<number>(
		`${organisation}/eod-vat/count`,
		filter.value,
	);

	return (
		<>
			<PageHeader title={'EOD VAT'} filter={filter} />
			<DataTable
				pagination={pagination}
				totalItems={eodVatCountQuery.data?.value}
				isRowsLoading={eodVatQuery.isLoading}
				isPaginationLoading={eodVatCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'Branch'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Date Time'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Till'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Operator'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Items'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Gross'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Net'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Refunds'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Paid Out'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Cash'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Card'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Misc'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Discounts'} />
						</Table.Th>
						<Table.Th>
							<Title label={'VAT'} />
						</Table.Th>
						<Table.Th />
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{eodVatQuery.data?.value.map((p) => (
						<EodVatRow originalEodVat={p} />
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
